import { SupportedLocales } from '@/models/localization.model';
import { FieldTypes, IUpdateSettingsDTO } from '@/models/settings.model';
import { SettingsFormFields, TSettingsFormValues } from '../helpers/types';

class UpdateSettingsDTO implements IUpdateSettingsDTO {
  [FieldTypes.ADDRESS]: { locale: Record<SupportedLocales, { name: string }> };
  [FieldTypes.CONTACT_EMAIL]: string;
  [FieldTypes.CONTACT_PHONE]: string;
  [FieldTypes.GOOGLE_ANALYTICS]?: string;
  [FieldTypes.FOP_MERCHANT]?: string;
  [FieldTypes.TOV_MERCHANT]?: string;
  [FieldTypes.FOP_MERCHANT_DESCRIPTION]?: string;
  [FieldTypes.TOV_MERCHANT_DESCRIPTION]?: string;
  [FieldTypes.FOP_CASH_REGISTER_ID]?: string;
  [FieldTypes.TOV_CASH_REGISTER_ID]?: string;
  [FieldTypes.FOP_CASHIER_NAME]?: string;
  [FieldTypes.TOV_CASHIER_NAME]?: string;
  [FieldTypes.FOP_FISCAL_DEPARTMENT]?: string;
  [FieldTypes.TOV_FISCAL_DEPARTMENT]?: string;
  [FieldTypes.ORDER_EMAILS]: string[];
  [FieldTypes.ADMIN_EMAILS]: string[];
  [FieldTypes.PRICE_CHANGE_ADMIN_EMAILS]: string[];
  [FieldTypes.SOCIAL_LINKS]: Record<string, string | undefined>;
  [FieldTypes.WORKING_HOURS]: { locale: Record<SupportedLocales, { name: string }> };
  [FieldTypes.MIN_ORDER_TOTAL]: number;
  external_map_id?: string;
  latitude?: string;
  longitude?: string;

  constructor(values: TSettingsFormValues) {
    this[FieldTypes.CONTACT_EMAIL] = values[SettingsFormFields.CONTACT_EMAIL];
    this[FieldTypes.CONTACT_PHONE] = values[SettingsFormFields.CONTACT_PHONE];
    this[FieldTypes.GOOGLE_ANALYTICS] = values[SettingsFormFields.GOOGLE_ANALYTICS];
    this[FieldTypes.ORDER_EMAILS] = values[SettingsFormFields.ORDER_EMAILS];
    this[FieldTypes.ADMIN_EMAILS] = values[SettingsFormFields.ADMIN_EMAILS];
    this[FieldTypes.PRICE_CHANGE_ADMIN_EMAILS] = values[SettingsFormFields.PRICE_CHANGE_ADMIN_EMAILS];
    this[FieldTypes.SOCIAL_LINKS] = {
      facebook: values[SettingsFormFields.FACEBOOK] || undefined,
      instagram: values[SettingsFormFields.INSTAGRAM] || undefined,
      twitter: values[SettingsFormFields.TWITTER] || undefined,
      threads: values[SettingsFormFields.THREADS] || undefined,
      viber: values[SettingsFormFields.VIBER] || undefined,
      telegram: values[SettingsFormFields.TELEGRAM] || undefined,
      tiktok: values[SettingsFormFields.TIK_TOK] || undefined,
      youtube: values[SettingsFormFields.YOUTUBE] || undefined,
    };
    this[FieldTypes.FOP_MERCHANT] = values[SettingsFormFields.FOP_ID];
    this[FieldTypes.FOP_MERCHANT_DESCRIPTION] = values[SettingsFormFields.FOP_DESCRIPTION];
    this[FieldTypes.TOV_MERCHANT] = values[SettingsFormFields.TOV_ID];
    this[FieldTypes.TOV_MERCHANT_DESCRIPTION] = values[SettingsFormFields.TOV_DESCRIPTION];
    this[FieldTypes.MIN_ORDER_TOTAL] = Number(values[SettingsFormFields.MIN_ORDER_TOTAL]);
    this[FieldTypes.FOP_CASH_REGISTER_ID] = values[SettingsFormFields.FOP_CASH_REGISTER_ID];
    this[FieldTypes.TOV_CASH_REGISTER_ID] = values[SettingsFormFields.TOV_CASH_REGISTER_ID];
    this[FieldTypes.FOP_CASHIER_NAME] = values[SettingsFormFields.FOP_CASHIER_NAME];
    this[FieldTypes.TOV_CASHIER_NAME] = values[SettingsFormFields.TOV_CASHIER_NAME];
    this[FieldTypes.FOP_FISCAL_DEPARTMENT] = values[SettingsFormFields.FOP_FISCAL_DEPARTMENT];
    this[FieldTypes.TOV_FISCAL_DEPARTMENT] = values[SettingsFormFields.TOV_FISCAL_DEPARTMENT];

    const address = values?.[SettingsFormFields.ADDRESS];

    if (typeof address !== 'string') {
      this.external_map_id = address.place_id;
      this.latitude = address.latitude.toString();
      this.longitude = address.longitude.toString();
    }
    this[FieldTypes.ADDRESS] = address;
    this[FieldTypes.WORKING_HOURS] = {
      locale: {
        [SupportedLocales.RU]: {
          name: values?.[SettingsFormFields.LOCALE]?.[SupportedLocales.RU]?.[SettingsFormFields.WORKING_HOURS],
        },
        [SupportedLocales.UK]: {
          name: values?.[SettingsFormFields.LOCALE]?.[SupportedLocales.UK]?.[SettingsFormFields.WORKING_HOURS],
        },
      },
    };
  }
}

export default UpdateSettingsDTO;
